module.exports = __webpack_public_path__ + "img/ff-home.34882e15.jpg";